import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Confirmation from './Confirmation';
import Modal from '../Modal';

interface Props {
	title: string;
	text: string;
	imageSource?: string;
	isOpen: boolean;
	onClose: () => void;
	children?: React.ReactElement | React.ReactElement[];
	size?: Size;
}

const ConfirmationModal: React.FC<Props> = ({
	isOpen,
	onClose,
	title,
	text,
	imageSource,
	children,
	size = Size.MD,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={false} size={size}>
			<Modal.Header title={title} />
			<Modal.Content contentScroll>
				<Confirmation text={text} imageSource={imageSource}>
					{children}
				</Confirmation>
			</Modal.Content>
		</Modal>
	);
};

export default ConfirmationModal;
